import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  show: PropTypes.number.isRequired,
};

const Spinner = ({ show }) => (
  <div className={show ? 'spinner-container' : 'spinner-container hidden-xs-up'}>
    <i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw spinner" />
    <span className="sr-only">Loading...</span>
  </div>
);

Spinner.propTypes = propTypes;

export default Spinner;
